import ChartCard from './ChartCard.component';

export default ChartCard;
